import { ITrayProps, Tray } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';

export type ButtonTrayProps = ITrayProps;

function ButtonTray({ className, spacing = 3, ...trayProps }: ButtonTrayProps) {
  const classes = classNames('button-tray', className);
  return <Tray spacing={spacing} className={classes} {...trayProps} />;
}

export default ButtonTray;
